import React from 'react';

import { useCertificateDownload } from '~/backup/shared/useCertificateDownload';
import {
  DownloadIconButton,
  IconButtonProps,
} from '~/packages/common-frontend/components/IconButton';

/**
 * Downloads one cycle's certificate PDF in one click, the certificate's
 * counterpart to the data pipeline's `DownloadInstanceIconButton`. `label`
 * names what is downloaded, e.g. "Harbor Deal certificate".
 */
export function CertificateDownloadIconButton({
  servicingCycleId,
  label,
  size,
}: {
  servicingCycleId: string;
  label: string;
  /** Chakra's button size; the default when omitted. */
  size?: IconButtonProps['size'];
}): React.ReactElement {
  const { download, loading } = useCertificateDownload();
  return (
    <DownloadIconButton
      ariaLabel={`Download ${label}`}
      label={`Download ${label}`}
      isLoading={loading}
      size={size}
      onClick={(): void => download(servicingCycleId)}
    />
  );
}
